import React from 'react';
import PropTypes from 'prop-types';

import { BLACK } from '@constant/colors';

const Locked = ({ className, color }) => (
  <svg className={className} viewBox="0 0 22 29">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9998 0.25C7.64011 0.25 4.9165 2.9736 4.9165 6.33333V10.9167H4.33317C2.4462 10.9167 0.916504 12.4464 0.916504 14.3333V25C0.916504 26.887 2.4462 28.4167 4.33317 28.4167H17.6665C19.5535 28.4167 21.0832 26.887 21.0832 25V14.3333C21.0832 12.4464 19.5535 10.9167 17.6665 10.9167H17.0832V6.33333C17.0832 2.9736 14.3596 0.25 10.9998 0.25ZM15.5832 6.33333V10.9167H6.4165V6.33333C6.4165 3.80203 8.46853 1.75 10.9998 1.75C13.5311 1.75 15.5832 3.80203 15.5832 6.33333ZM2.4165 14.3333C2.4165 13.2748 3.27462 12.4167 4.33317 12.4167H17.6665C18.725 12.4167 19.5832 13.2748 19.5832 14.3333V25C19.5832 26.0585 18.725 26.9167 17.6665 26.9167H4.33317C3.27462 26.9167 2.4165 26.0585 2.4165 25V14.3333ZM14.8843 18.1754C15.1652 17.871 15.1462 17.3965 14.8419 17.1156C14.5375 16.8346 14.063 16.8536 13.7821 17.158L10.2774 20.9547L8.16038 19.1023C7.84865 18.8295 7.37483 18.8611 7.10207 19.1728C6.82931 19.4845 6.8609 19.9584 7.17263 20.2311L9.83929 22.5645C10.1452 22.8321 10.6086 22.8074 10.8843 22.5087L14.8843 18.1754Z"
      fill={color}
    />
  </svg>
);

Locked.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Locked.defaultProps = {
  color: BLACK,
};

export default Locked;
